import { useQuery } from 'react-query'
import { fetchDynamicPage } from 'services/content'

export function useDynamicPage(path: string) {
  return useQuery(['page', path], () => fetchDynamicPage(path))
}
